import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { isAuthenticated, authFetch } from '../services/api';

export default function AcceptInvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error | login_required
  const [detail, setDetail] = useState('');
  const [projectId, setProjectId] = useState(null);

  useEffect(() => {
    if (!isAuthenticated()) {
      // Save token in sessionStorage so we can resume after login
      sessionStorage.setItem('pending_invite_token', token);
      setStatus('login_required');
      return;
    }
    accept();
  }, [token]);

  const accept = async () => {
    try {
      const res = await authFetch(`/api/collab/invitations/accept/${token}`);
      const data = await res.json();
      if (res.ok) {
        setProjectId(data.project_id);
        setStatus('success');
        // Redirect to the project after 2s
        setTimeout(() => navigate(`/app?project=${data.project_id}`), 2000);
      } else {
        setDetail(data.detail || 'Invitation could not be accepted.');
        setStatus('error');
      }
    } catch {
      setDetail('Network error. Please try again.');
      setStatus('error');
    }
  };

  if (status === 'login_required') {
    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={s.icon}>🔐</div>
          <h2 style={s.title}>Login Required</h2>
          <p style={s.sub}>You need to be logged in to accept this invitation.</p>
          <button style={s.btn} onClick={() => navigate(`/login?redirect=/invite/accept/${token}`)}>
            Log in to Accept
          </button>
        </div>
      </div>
    );
  }

  if (status === 'loading') {
    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={{ ...s.icon, animation: 'spin 1s linear infinite' }}>⟳</div>
          <h2 style={s.title}>Accepting invitation...</h2>
          <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={s.icon}>🎉</div>
          <h2 style={s.title}>You're in!</h2>
          <p style={s.sub}>Invitation accepted. Redirecting to the project...</p>
          <button style={s.btn} onClick={() => navigate(`/app?project=${projectId}`)}>
            Open Project Now
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.icon}>❌</div>
        <h2 style={s.title}>Invitation Failed</h2>
        <p style={s.sub}>{detail}</p>
        <button style={s.btn} onClick={() => navigate('/app')}>Go to Dashboard</button>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 16, padding: '48px 40px', textAlign: 'center', maxWidth: 400, width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' },
  icon: { fontSize: 48, marginBottom: 16, display: 'inline-block' },
  title: { fontSize: 22, fontWeight: 700, color: '#f1f5f9', margin: '0 0 10px' },
  sub: { fontSize: 14, color: '#94a3b8', margin: '0 0 24px', lineHeight: 1.6 },
  btn: { padding: '10px 24px', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
};
